import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { setNewSchedule, scheduleEditApi, limitList } from "../../api";
import { scheduleEdit } from "../../redux";
import { Alert } from "../";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FiClock, FiPower, FiCalendar, FiCheck, FiArrowLeft, FiRepeat, FiSun } from "react-icons/fi";

var days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const ScheduleCompp = (props) => {
  const { t } = useTranslation();
  var daysFA = [
    t("شنبه"),
    t("یکشنبه"),
    t("دوشنبه"),
    t("سه شنبه"),
    t("چهارشنبه"),
    t("پنجشنبه"),
    t("جمعه"),
  ];
  const { zone, command, toggleSchedule, scheduleData } = props;
  const [startDate, setStartDate] = useState(new Date());
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const [once, setOnce] = useState("0");
  const [scheduleEnDate, setScheduleEnDate] = useState(
    scheduleData?.start_date
      ?.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
      .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
  );
  let days2 = scheduleData?.days?.split(",");

  const [dayIndex, setDayIndex] = useState([
    { index: 0, isActive: scheduleData && days2?.includes("1") ? true : false },
    { index: 1, isActive: scheduleData && days2?.includes("2") ? true : false },
    { index: 2, isActive: scheduleData && days2?.includes("3") ? true : false },
    { index: 3, isActive: scheduleData && days2?.includes("4") ? true : false },
    { index: 4, isActive: scheduleData && days2?.includes("5") ? true : false },
    { index: 5, isActive: scheduleData && days2?.includes("6") ? true : false },
    { index: 6, isActive: scheduleData && days2?.includes("7") ? true : false },
  ]);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const [time, setTime] = useState(scheduleData?.time || "12:00");
  const [date, setDate] = useState();
  const [dayNumber, setDayNumber] = useState(scheduleData ? days2 : []);

  // Drag functionality refs
  const hourRef = useRef(null);
  const minuteRef = useRef(null);
  const isDraggingHour = useRef(false);
  const isDraggingMinute = useRef(false);
  const startYHour = useRef(0);
  const startYMinute = useRef(0);
  const startHourValue = useRef(0);
  const startMinuteValue = useRef(0);

  function submitExample({ value }) {
    const date = value._d
      .toLocaleDateString("fa-IR")
      .replace(/([۰-۹])/g, (token) =>
        String.fromCharCode(token.charCodeAt(0) - 1728)
      );
    setDate(date);
  }

  const dayClicked = (i) => {
    if (!dayIndex[i].isActive) {
      setDayIndex(
        dayIndex.map((item) =>
          item.index === i ? { ...item, isActive: true } : item
        )
      );
      setDayNumber((prev) => [...prev, i + 1]);
    } else {
      setDayIndex(
        dayIndex.map((item) =>
          item.index === i ? { ...item, isActive: false } : item
        )
      );
      setDayNumber(dayNumber.filter((item) => item !== i + 1));
    }
  };

  const setScheduleCommand = () => {
    const data = new FormData();
    data.append("serial", zone.serial);
    data.append("widget", zone.id);
    data.append("time", time !== undefined ? time : scheduleData.time);
    data.append("once", once);
    if (date !== undefined) {
      data.append("start_date", date);
    }
    if (once === "0") {
      data.append(
        "days",
        dayNumber.length !== 0 || dayNumber !== undefined
          ? dayNumber
          : scheduleData.days
      );
    }
    if (scheduleData !== undefined) {
      data.append("command", scheduleData.command);
      data.append("schedule", scheduleData.id);
      scheduleEditApi(data, token)
        .then(() => {
          setShowAlert({
            show: true,
            message: t("زمانبندی با موفقیت ویرایش شد."),
            type: "Success",
          });
          setTimeout(() => {
            setShowAlert((prev) => ({ ...prev, show: false }));
            toggleSchedule();
          }, 2000);
          dispatch(
            scheduleEdit({
              id: scheduleData.id,
              time: time !== undefined ? time : scheduleData.time,
              start_date: date,
              days: dayNumber.length !== 0 ? dayNumber.toString() : scheduleData.days,
              once: once,
            })
          );
        })
        .catch((err) => {
          if (err.response?.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
          }
        });
    } else {
      data.append("command", command.command);
      setNewSchedule(data, token)
        .then(() => {
          setShowAlert({
            show: true,
            message: t("زمانبندی با موفقیت ثبت شد."),
            type: "Success",
          });
          setTimeout(() => {
            setShowAlert((prev) => ({ ...prev, show: false }));
            toggleSchedule();
          }, 2000);
        })
        .catch((err) => {
          if (err.response?.status === 400) {
            limitList(token).then((result) => {
              if (result.data.data.schedule_limit) {
                setShowAlert({
                  show: true,
                  message: t("موارد بالا را تکمیل نمایید."),
                  type: "Error",
                });
              } else {
                setShowAlert({
                  show: true,
                  message: t(" سقف مجاز برای زمانبندی به اتمام رسیده است."),
                  type: "Error",
                });
              }
              setTimeout(() => setShowAlert((prev) => ({ ...prev, show: false })), 3000);
            });
          }
          if (err.response?.status === 403) {
            Cookies.remove("token");
            props.history.push("/login");
          }
        });
    }
  };

  useEffect(() => {
    let d = new Date();
    let dayName = days[d.getDay()];
  }, []);

  const onceChanged = (e) => {
    setOnce(e.target.checked ? "1" : "0");
  };

  // Hour drag handlers
  const handleHourMouseDown = (e) => {
    isDraggingHour.current = true;
    startYHour.current = e.clientY;
    startHourValue.current = parseInt(time?.split(':')[0]) || 0;
    document.body.style.userSelect = 'none';
  };

  const handleHourMouseMove = (e) => {
    if (!isDraggingHour.current) return;
    const deltaY = startYHour.current - e.clientY;
    const deltaHours = Math.floor(deltaY / 20);
    if (deltaHours !== 0) {
      let newHour = startHourValue.current + deltaHours;
      newHour = ((newHour % 24) + 24) % 24;
      setTime(`${String(newHour).padStart(2, '0')}:${time?.split(':')[1] || '00'}`);
      startHourValue.current = newHour;
      startYHour.current = e.clientY;
    }
  };

  const handleHourMouseUp = () => {
    isDraggingHour.current = false;
    document.body.style.userSelect = '';
  };

  // Minute drag handlers
  const handleMinuteMouseDown = (e) => {
    isDraggingMinute.current = true;
    startYMinute.current = e.clientY;
    startMinuteValue.current = parseInt(time?.split(':')[1]) || 0;
    document.body.style.userSelect = 'none';
  };

  const handleMinuteMouseMove = (e) => {
    if (!isDraggingMinute.current) return;
    const deltaY = startYMinute.current - e.clientY;
    const deltaMinutes = Math.floor(deltaY / 10);
    if (deltaMinutes !== 0) {
      let newMinute = startMinuteValue.current + deltaMinutes;
      newMinute = ((newMinute % 60) + 60) % 60;
      setTime(`${time?.split(':')[0] || '00'}:${String(newMinute).padStart(2, '0')}`);
      startMinuteValue.current = newMinute;
      startYMinute.current = e.clientY;
    }
  };

  const handleMinuteMouseUp = () => {
    isDraggingMinute.current = false;
    document.body.style.userSelect = '';
  };

  // Wheel handlers for scroll
  const handleHourWheel = (e) => {
    e.preventDefault();
    const delta = e.deltaY > 0 ? 1 : -1;
    let currentHour = parseInt(time?.split(':')[0]) || 0;
    let newHour = currentHour + delta;
    if (newHour < 0) newHour = 23;
    if (newHour > 23) newHour = 0;
    setTime(`${String(newHour).padStart(2, '0')}:${time?.split(':')[1] || '00'}`);
  };

  const handleMinuteWheel = (e) => {
    e.preventDefault();
    const delta = e.deltaY > 0 ? 1 : -1;
    let currentMinute = parseInt(time?.split(':')[1]) || 0;
    let newMinute = currentMinute + delta;
    if (newMinute < 0) newMinute = 59;
    if (newMinute > 59) newMinute = 0;
    setTime(`${time?.split(':')[0] || '00'}:${String(newMinute).padStart(2, '0')}`);
  };

  // Add event listeners
  useEffect(() => {
    const hourElement = hourRef.current;
    const minuteElement = minuteRef.current;
    
    if (hourElement) {
      hourElement.addEventListener('wheel', handleHourWheel, { passive: false });
      return () => hourElement.removeEventListener('wheel', handleHourWheel);
    }
  }, [time]);

  useEffect(() => {
    const minuteElement = minuteRef.current;
    if (minuteElement) {
      minuteElement.addEventListener('wheel', handleMinuteWheel, { passive: false });
      return () => minuteElement.removeEventListener('wheel', handleMinuteWheel);
    }
  }, [time]);

  // Auto-scroll to selected time
  useEffect(() => {
    const selectedHourIndex = parseInt(time?.split(':')[0]) || 0;
    const hourScrollContainer = document.querySelector('.time-column:first-child .time-scroll');
    if (hourScrollContainer && hourScrollContainer.children[selectedHourIndex]) {
      hourScrollContainer.children[selectedHourIndex].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    
    const selectedMinute = parseInt(time?.split(':')[1]) || 0;
    const minuteScrollContainer = document.querySelector('.time-column:last-child .time-scroll');
    if (minuteScrollContainer && minuteScrollContainer.children[selectedMinute]) {
      minuteScrollContainer.children[selectedMinute].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, []);

  const isOn = scheduleData 
    ? scheduleData.command == "11" 
    : command?.command == "11";

  return (
    <div className="setting-container" style={{ minHeight: "auto", padding: "24px" }}>
      <h2 className="setting-title">{t("زمانبندی")}</h2>

      {/* Command Info */}
      <div className="schedule-command-info">
        <div className="schedule-command-icon">
          <FiPower size={24} />
        </div>
        <div>
          <p className="schedule-command-label">
            {isOn ? t("خاموش") : t("روشن")}
          </p>
          <p className="schedule-zone-name">{zone.caption}</p>
        </div>
      </div>

      {/* Time Picker - Apple Style with Drag */}
      <div className="schedule-time-section">
        <div className="schedule-section-title">
          <FiClock size={16} />
          <span>{t("زمان")}</span>
        </div>
        <div className="apple-time-picker">
          <div className="time-columns">
            {/* Hours Column */}
            <div className="time-column">
              <div 
                className="time-scroll drag-area"
                ref={hourRef}
                onMouseDown={handleHourMouseDown}
                onMouseMove={handleHourMouseMove}
                onMouseUp={handleHourMouseUp}
                onMouseLeave={handleHourMouseUp}
              >
                {Array.from({ length: 24 }, (_, i) => i).map((hour) => (
                  <div
                    key={hour}
                    className={`time-option ${parseInt(time?.split(':')[0]) === hour ? 'active' : ''}`}
                    onClick={() => setTime(`${String(hour).padStart(2, '0')}:${time?.split(':')[1] || '00'}`)}
                  >
                    {String(hour).padStart(2, '0')}
                  </div>
                ))}
              </div>
              <span className="time-label">{t("ساعت")}</span>
            </div>
            
            {/* Minutes Column */}
            <div className="time-column">
              <div 
                className="time-scroll drag-area"
                ref={minuteRef}
                onMouseDown={handleMinuteMouseDown}
                onMouseMove={handleMinuteMouseMove}
                onMouseUp={handleMinuteMouseUp}
                onMouseLeave={handleMinuteMouseUp}
              >
                {Array.from({ length: 60 }, (_, i) => i).map((minute) => (
                  <div
                    key={minute}
                    className={`time-option ${parseInt(time?.split(':')[1]) === minute ? 'active' : ''}`}
                    onClick={() => setTime(`${time?.split(':')[0] || '00'}:${String(minute).padStart(2, '0')}`)}
                  >
                    {String(minute).padStart(2, '0')}
                  </div>
                ))}
              </div>
              <span className="time-label">{t("دقیقه")}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Once Only Toggle */}
      <div className="schedule-toggle-section">
        <div className="schedule-toggle-card">
          <div className="schedule-toggle-info">
            <FiRepeat size={18} />
            <div>
              <p className="toggle-title">{t("فقط یکبار")}</p>
              <p className="toggle-description">{t("زمانبندی فقط یک بار اجرا شود")}</p>
            </div>
          </div>
          <label className="schedule-toggle-switch">
            <input
              type="checkbox"
              defaultChecked={scheduleData ? scheduleData.once : once === "1"}
              onChange={onceChanged}
            />
            <span className="schedule-toggle-slider"></span>
          </label>
        </div>
      </div>

      {/* Days Selection */}
      {once === "0" && (
        <div className="schedule-days-section">
          <div className="schedule-section-title">
            <FiSun size={16} />
            <span>{t("روزهای هفته")}</span>
          </div>
          <div className="days-wrapper">
            {daysFA.map((day, i) => (
              <span
                key={i}
                className={`day-chip ${dayIndex[i]?.isActive ? "active" : ""}`}
                onClick={() => dayClicked(i)}
              >
                {day}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Date Picker */}
      <div className="schedule-date-section">
        <div className="schedule-section-title">
          <FiCalendar size={16} />
          <span>{t("تاریخ")}</span>
        </div>
        <div className="date-picker-wrapper">
          <ReactDatePicker
            onChange={(date) => setStartDate(date)}
            selected={startDate}
            onClickSubmitButton={(val) => submitExample(val)}
            className="schedule-datepicker"
            placeholderText={t("انتخاب تاریخ")}
          />
        </div>
      </div>

      {/* Action Buttons */}
      <div className="setting-buttons">
        <button
          type="button"
          className="setting-back-btn"
          onClick={toggleSchedule}
          style={{ background: "var(--bg-white)", color: "var(--text-primary)", border: "2px solid var(--border-color)" }}
        >
          <FiArrowLeft size={18} />
          <span>{t("بازگشت")}</span>
        </button>
        <button type="button" className="setting-back-btn" onClick={setScheduleCommand}>
          <FiCheck size={18} />
          <span>{t("تائید")}</span>
        </button>
      </div>

      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </div>
  );
};

const Schedule = withRouter(ScheduleCompp);

export { Schedule };